import { RpcError } from "grpc-web";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";
import { GetDashBoardDetailsRequest, GetDashBoardDetailsResponse, GetDashBoardProjectFilesRequest, GetDashBoardProjectFilesResponse, GetDashBoardProjectsRequest, GetDashBoardProjectsResponse, GetDashBoardPublishedTracksRequest, GetDashBoardPublishedTracksResponse, GetDashBoardTracksRequest, GetDashBoardTracksResponse, GetDashBoardUsersRequest, GetDashBoardUsersResponse } from "../proto/api_pb";

export const getDashBoardDetails: (
    token: string,
    userId: string,
    enterpriseId: string,
) => Promise<RpcError | GetDashBoardDetailsResponse> = async (
    token: string,
    userId: string,
    enterpriseId: string,
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetDashBoardDetailsRequest();
        request.setUserId(userId);
        request.setEnterpriseId(enterpriseId);
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<GetDashBoardDetailsResponse | RpcError>((resolve, reject) => {
                    ommuseClient.getDashBoardDetails(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    }

export const getDashBoardTracks: (
    token: string,
    userId: string,
    enterpriseId: string,
) => Promise<RpcError | GetDashBoardTracksResponse> = async (
    token: string,
    userId: string,
    enterpriseId: string,
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetDashBoardTracksRequest();
        request.setUserId(userId);
        request.setEnterpriseId(enterpriseId);
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<GetDashBoardTracksResponse | RpcError>((resolve, reject) => {
                    ommuseClient.getDashBoardTracks(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    }

export const getDashBoardProjectFiles: (
    token: string,
    userId: string,
    enterpriseId: string,
) => Promise<RpcError | GetDashBoardProjectFilesResponse> = async (
    token: string,
    userId: string,
    enterpriseId: string,
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetDashBoardProjectFilesRequest();
        request.setUserId(userId);
        request.setEnterpriseId(enterpriseId);
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<GetDashBoardProjectFilesResponse | RpcError>((resolve, reject) => {
                    ommuseClient.getDashBoardProjectFiles(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    }

export const getDashBoardProjects: (
    token: string,
    userId: string,
    enterpriseId: string,
) => Promise<RpcError | GetDashBoardProjectsResponse> = async (
    token: string,
    userId: string,
    enterpriseId: string,
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetDashBoardProjectsRequest();
        request.setUserId(userId);
        request.setEnterpriseId(enterpriseId);
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<GetDashBoardProjectsResponse | RpcError>((resolve, reject) => {
                    ommuseClient.getDashBoardProjects(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    }

export const getDashBoardPublishedTracks: (
    token: string,
    userId: string,
    enterpriseId: string,
) => Promise<RpcError | GetDashBoardPublishedTracksResponse> = async (
    token: string,
    userId: string,
    enterpriseId: string,
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetDashBoardPublishedTracksRequest();
        request.setUserId(userId);
        request.setEnterpriseId(enterpriseId);
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<GetDashBoardPublishedTracksResponse | RpcError>((resolve, reject) => {
                    ommuseClient.getDashBoardPublishedTracks(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    }

export const getDashBoardUsers: (
    token: string,
    userId: string,
    enterpriseId: string,
) => Promise<RpcError | GetDashBoardUsersResponse> = async (
    token: string,
    userId: string,
    enterpriseId: string,
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetDashBoardUsersRequest();
        request.setUserId(userId);
        request.setEnterpriseId(enterpriseId);
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<GetDashBoardUsersResponse | RpcError>((resolve, reject) => {
                    ommuseClient.getDashBoardUsers(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    }